import { render, staticRenderFns } from "./add-generic-entry.vue?vue&type=template&id=96e806fc&scoped=true"
import script from "./add-generic-entry.vue?vue&type=script&lang=js"
export * from "./add-generic-entry.vue?vue&type=script&lang=js"
import style0 from "./add-generic-entry.vue?vue&type=style&index=0&id=96e806fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e806fc",
  null
  
)

export default component.exports